var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-frame',{class:_vm.$style.Modal},[_c('view-header',{attrs:{"title":_vm.title,"back":_vm.back}}),_c('view-body',{ref:"ViewBody",staticClass:"p-4"},[_vm._t("default")],2),_c('view-footer',[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }